import { useTranslation } from 'react-i18next';
import { useBaseHistory } from 'spindl-shared-components';

import { PathSelectorCombinedProps } from './types';

const usePresenter = (props: PathSelectorCombinedProps): PathSelectorCombinedProps => {

  const { t } = useTranslation();
  const history = useBaseHistory();

  const handleCloseWizard = () => {
    history.push('/');
  };

  const handleInviteUsers = () => {
    history.push('/wizard/inviteUsers');
  };

  const handleDownloadCSV = () => {
    history.push('/wizard/downloadCSV');
  };

  return {
    ...props,
    label: {
      value: t('path_select.header'),
    },
    instructions: {
      value: t('path_select.description'),
    },
    emailPathButton: {
      icon: {
        asset: 'EmailCircle',
      },
      label: {
        value: t('path_select.email.label'),
      },
      description: {
        value: t('path_select.email.description'),
      },
      onClick: handleInviteUsers,
    },
    cSVPathButton: {
      icon: {
        asset: 'DocumentCircle',
      },
      label: {
        value: t('path_select.csv.label'),
      },
      description: {
        value: t('path_select.csv.description'),
      },
      onClick: handleDownloadCSV,
    },
    button: {
      onClick: handleCloseWizard,
    },
  };
};

export default usePresenter;
